import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addRreportConfig from "./components/addRreportConfig";
export default {
  name: "reportConfigurationManagement",
  mixins: [loadMoreList, packageData],
  components: {
    addRreportConfig: addRreportConfig
  },
  data: function data() {
    return {
      pagingReqFn: "reportConfigList",
      delIds: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'reportConfigDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    }
  }
};